import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import './styles/tokens.css'
import './styles/base.css'
import './styles/app.css'
import { App } from './App.js'
import { registerServiceWorker, requestPersistentStorage } from './lib/offline.js'

/**
 * Inside a native shell the app is served as a FILE by WebViewAssetLoader
 * (Android) or from a bundle (iOS). Those serve files, not SPA fallbacks, so a
 * path-based route like /board would 404. Hash routing sidesteps it entirely.
 * On the web we keep clean paths.
 */
const inNativeShell =
  typeof window !== 'undefined' &&
  (Boolean((window as { OfficeOS?: unknown }).OfficeOS) ||
    window.location.protocol === 'file:' ||
    window.location.pathname.endsWith('/index.html'))

const Router = inNativeShell ? HashRouter : BrowserRouter

// Offline boot. Registered AFTER render so a service-worker problem can never
// stop the app appearing -- on a wall display a blank screen is the worst
// possible failure mode, and a missing cache is only a slow first load.
if (!inNativeShell) {
  window.addEventListener('load', () => {
    void registerServiceWorker(status => {
      if (status.state === 'failed') console.warn('service worker:', status.error)
    })
    void requestPersistentStorage()
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
)
